import { useReducer } from 'react';
const initialState = {
    offset: 0,
    searchKey: 'name',
    searchValue: '',
    limit: 6,
    visibility: 'all',
};
function reducer(state, action) {
    switch (action.type) {
        case 'SET_OFFSET':
            return Object.assign(Object.assign({}, state), { offset: action.payload });
        case 'SET_SEARCH_KEY':
            return Object.assign(Object.assign({}, state), { searchKey: action.payload, offset: 0 });
        case 'SET_SEARCH_VALUE':
            return Object.assign(Object.assign({}, state), { searchValue: action.payload, offset: 0 });
        case 'SET_VISIBILITY':
            return Object.assign(Object.assign({}, state), { visibility: action.payload, offset: 0 });
        case 'RESET_STATE':
        default:
            return initialState;
    }
}
export function useContactLibraryState() {
    const [state, dispatch] = useReducer(reducer, initialState);
    const setSearchKey = (key) => dispatch({ type: 'SET_SEARCH_KEY', payload: key });
    const setSearchValue = (value) => dispatch({ type: 'SET_SEARCH_VALUE', payload: value });
    const resetState = () => dispatch({ type: 'RESET_STATE' });
    const setOffset = (offset) => dispatch({ type: 'SET_OFFSET', payload: offset });
    const setVisibility = (visibility) => dispatch({ type: 'SET_VISIBILITY', payload: visibility });
    return {
        state,
        setSearchKey,
        setSearchValue,
        resetState,
        setOffset,
        setVisibility,
    };
}
